module.exports = __webpack_public_path__ + "static/media/image2.ad3c8718.png";